import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BlockUIService } from 'ng-block-ui';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  inLoading: boolean = false;
  loaded: boolean = false;
  blockCounter: number = 0;
  logging: boolean = false;

  constructor(private blockUI: BlockUIService,
    @Inject(DOCUMENT) private document: any) {
  }

  start(from: string): boolean {
    if (this.logging) { console.log('start ' + from + ' ' + this.inLoading + ' ' + this.blockCounter); }
    if (this.inLoading) {
      return false;
    }
    this.inLoading = true;
    this.loaded = false;
    this.blockCounter++;
    this.document.body.classList.add('loading');
    return true;
  }

  end(from: string): void {
    if (this.logging) { console.log('end ' + from + ' ' + this.inLoading + ' ' + this.blockCounter); }
    this.blockCounter--;
    this.loaded = true;
    this.check();
  }

  inc(from: string): void {
    if (this.logging) { console.log('inc ' + from + ' ' + this.inLoading + ' ' + this.blockCounter); }
    this.blockCounter++;
    if (!this.inLoading) {
      this.blockUI.start('ajaxCall');
    }
  }

  dec(from: string): void {
    if (this.logging) { console.log('dec ' + from + ' ' + this.inLoading + ' ' + this.blockCounter); }
    this.blockCounter--;
    if (!this.inLoading) {
      this.blockUI.stop('ajaxCall');
    }
    this.check();
  }

  // Forcefully stop any lingering block-ui overlay.
  public reset(): void {
    this.blockCounter = 0;
    this.inLoading = false;
    this.loaded = true;
    this.blockUI.stop('ajaxCall');
    this.document.body.classList.remove('loading');
  }

  private check(): void {
    if (this.blockCounter == 0 && this.loaded) {
      if (this.logging) { console.log('check done'); }
      this.inLoading = false;
      this.document.body.classList.remove('loading');
    }
  }
}
